import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Sancionaa.css";

import ModalCreaSancion from "./Modal";
import CadetesBuscador from "./CadetesBuscador";
import CreaSancion from "./CreaSancion";

import ObtieneSancionesUsuario from "./ObtieneSancionesUsuario";
import ObtieneSancionesANotificar from "./ObtieneSancionesANotificar";
import ObtieneSancionesAConfirmar from "./ObtieneSancionesAConfirmar";
import ObtieneSancionesANotificarFirmes from "./ObtieneSancionesANotificarFirmes";
import ObtieneSancionesRecursadas from "./ObtieneSancionesRecursadas";

import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";
import socket from "../tools/socke";

import NotificationProvider from "./NotificationProvider";

const Sancionaa = () => {
  const navigate = useNavigate();
  const Usuario = ObtieneDatosCookies();

  // ============================================================
  // ESTADOS
  // ============================================================

  const [verSancionar, setVerSancionar] = useState(false);

  const [
    cadeteSeleccionado,
    setCadeteSeleccionado,
  ] = useState(null);

  /*
   * En vez de desmontar/remontar con true/false,
   * usamos un contador de refresco.
   *
   * Cada actualización incrementa el valor y los componentes
   * hijos reciben una prop diferente.
   */
  const [refresco, setRefresco] = useState(0);

  const {
    addNotification,
    NotificationContainer,
  } = NotificationProvider();

  // ============================================================
  // PERMISOS
  // ============================================================

  const puedeReclamar = comprueboPermisos(
    Usuario?.funcion,
    "Reclama Sancion"
  );

  const puedeConfirmar = comprueboPermisos(
    Usuario?.funcion,
    "Confirma Sancion"
  );

  const esCuerpo = comprueboPermisos(
    Usuario?.funcion,
    "Cuerpo"
  );

  // ============================================================
  // REFRESCAR
  // ============================================================

  const refrescarSanciones = useCallback(() => {
    setRefresco((prev) => prev + 1);
  }, []);

  // ============================================================
  // ABRIR MODAL
  // ============================================================

  const abrirCrearSancion = () => {
    setCadeteSeleccionado(null);
    setVerSancionar(true);
  };

  // ============================================================
  // CERRAR MODAL
  // ============================================================

  const manejaCerradoSancionar = () => {
    setVerSancionar(false);
    setCadeteSeleccionado(null);
  };

  // ============================================================
  // SANCION CREADA / ACTUALIZADA
  // ============================================================

  const manejoCierreCreo = () => {
    refrescarSanciones();

    setVerSancionar(false);
    setCadeteSeleccionado(null);
  };

  // ============================================================
  // SOCKET
  // ============================================================

  useEffect(() => {
    const handleEstadoActualizable = () => {
      console.log("🔄 Actualizando módulo de sanciones");

      refrescarSanciones();
    };

    const handleAvisoActualizado = () => {
      addNotification(
        "¡Un cadete generó un aviso!"
      );
    };

    socket.on(
      "estadoActualizable",
      handleEstadoActualizable
    );

    socket.on(
      "avisoActualizado",
      handleAvisoActualizado
    );

    return () => {
      socket.off(
        "estadoActualizable",
        handleEstadoActualizable
      );

      socket.off(
        "avisoActualizado",
        handleAvisoActualizado
      );
    };
  }, [
    addNotification,
    refrescarSanciones,
  ]);

  // ============================================================
  // NOMBRE CADETE
  // ============================================================

  const nombreCadete = cadeteSeleccionado
    ? `${
        cadeteSeleccionado?.cadeteApellido || ""
      } ${
        cadeteSeleccionado?.cadeteNombre || ""
      }`.trim()
    : "";

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div className="san-v2-page">
      {/* Si el provider devuelve un contenedor visual */}
      {NotificationContainer}

      <div className="san-v2-container">

        {/* ==================================================== */}
        {/* HEADER */}
        {/* ==================================================== */}

        <section className="san-v2-header">
          <div>
            <span className="san-v2-eyebrow">
              DISCIPLINA · ISeP
            </span>

            <h1 className="san-v2-title">
              Sanciones Disciplinarias
            </h1>

            <p className="san-v2-subtitle">
              Gestión, seguimiento, notificación y resolución
              de sanciones disciplinarias de cadetes.
            </p>
          </div>

          <div className="san-v2-header-actions">
            <button
              type="button"
              className="san-v2-btn-secondary"
              onClick={() =>
                navigate("/usuarioLogueado/")
              }
            >
              ← Volver
            </button>

            <button
              type="button"
              className="san-v2-btn-primary"
              onClick={abrirCrearSancion}
            >
              <span>+</span>
              Crear sanción
            </button>
          </div>
        </section>

        {/* ==================================================== */}
        {/* RESUMEN / ACCESOS */}
        {/* ==================================================== */}

        <section className="san-v2-summary">
          <div className="san-v2-stat-card">
            <div className="san-v2-stat-icon">
              📑
            </div>

            <div>
              <span>
                Mis sanciones
              </span>

              <strong>
                Seguimiento
              </strong>

              <small>
                Sanciones generadas por el usuario
              </small>
            </div>
          </div>

          {esCuerpo && (
            <div className="san-v2-stat-card">
              <div className="san-v2-stat-icon san-v2-stat-icon-warning">
                🔔
              </div>

              <div>
                <span>
                  Notificaciones
                </span>

                <strong>
                  Pendientes
                </strong>

                <small>
                  Sanciones que requieren notificación
                </small>
              </div>
            </div>
          )}

          {puedeConfirmar && (
            <div className="san-v2-stat-card">
              <div className="san-v2-stat-icon san-v2-stat-icon-confirm">
                ✓
              </div>

              <div>
                <span>
                  Confirmación
                </span>

                <strong>
                  Control
                </strong>

                <small>
                  Sanciones pendientes de resolución
                </small>
              </div>
            </div>
          )}

          {puedeReclamar && (
            <div className="san-v2-stat-card">
              <div className="san-v2-stat-icon san-v2-stat-icon-recurso">
                ↺
              </div>

              <div>
                <span>
                  Recursos
                </span>

                <strong>
                  Reclamadas
                </strong>

                <small>
                  Sanciones recurridas por cadetes
                </small>
              </div>
            </div>
          )}
        </section>

        {/* ==================================================== */}
        {/* RECURSADAS */}
        {/* ==================================================== */}

        {puedeReclamar && (
          <section className="san-v2-section san-v2-section-recurso">
            <div className="san-v2-section-header">
              <div className="san-v2-section-title-group">
                <div className="san-v2-indicator san-v2-indicator-purple" />

                <div>
                  <h2>
                    Sanciones recurridas
                  </h2>

                  <p>
                    Presentaciones y recursos efectuados por
                    cadetes respecto de sanciones aplicadas.
                  </p>
                </div>
              </div>

              <span className="san-v2-section-badge">
                Recursos
              </span>
            </div>

            <div className="san-v2-section-content">
              <ObtieneSancionesRecursadas
                refresca={refresco}
              />
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* A CONFIRMAR */}
        {/* ==================================================== */}

        {puedeConfirmar && (
          <section className="san-v2-section">
            <div className="san-v2-section-header">
              <div className="san-v2-section-title-group">
                <div className="san-v2-indicator san-v2-indicator-warning" />

                <div>
                  <h2>
                    Sanciones a confirmar
                  </h2>

                  <p>
                    Expedientes disciplinarios que requieren
                    intervención y confirmación.
                  </p>
                </div>
              </div>

              <span className="san-v2-section-badge san-v2-badge-warning">
                Pendientes
              </span>
            </div>

            <div className="san-v2-section-content">
              <ObtieneSancionesAConfirmar
                refresca={refresco}
              />
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* A NOTIFICAR */}
        {/* ==================================================== */}

        {esCuerpo && (
          <section className="san-v2-section">
            <div className="san-v2-section-header">
              <div className="san-v2-section-title-group">
                <div className="san-v2-indicator san-v2-indicator-red" />

                <div>
                  <h2>
                    Sanciones a notificar
                  </h2>

                  <p>
                    Sanciones activas que todavía deben ser
                    notificadas al cadete.
                  </p>
                </div>
              </div>

              <span className="san-v2-section-badge san-v2-badge-red">
                Notificar
              </span>
            </div>

            <div className="san-v2-section-content">
              <ObtieneSancionesANotificar
                refresca={refresco}
              />
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* FIRMES A NOTIFICAR */}
        {/* ==================================================== */}

        {esCuerpo && (
          <section className="san-v2-section">
            <div className="san-v2-section-header">
              <div className="san-v2-section-title-group">
                <div className="san-v2-indicator san-v2-indicator-green" />

                <div>
                  <h2>
                    Sanciones firmes
                  </h2>

                  <p>
                    Resoluciones firmes que requieren la
                    notificación final correspondiente.
                  </p>
                </div>
              </div>

              <span className="san-v2-section-badge san-v2-badge-green">
                Firmes
              </span>
            </div>

            <div className="san-v2-section-content">
              <ObtieneSancionesANotificarFirmes
                refresca={refresco}
              />
            </div>
          </section>
        )}

        {/* ==================================================== */}
        {/* MIS SANCIONES */}
        {/* ==================================================== */}

        <section className="san-v2-section">
          <div className="san-v2-section-header">
            <div className="san-v2-section-title-group">
              <div className="san-v2-indicator san-v2-indicator-blue" />

              <div>
                <h2>
                  Sanciones generadas
                </h2>

                <p>
                  Historial y seguimiento de las sanciones
                  gestionadas desde su usuario.
                </p>
              </div>
            </div>

            <span className="san-v2-section-badge san-v2-badge-blue">
              Historial
            </span>
          </div>

          <div className="san-v2-section-content">
            <ObtieneSancionesUsuario
              refresca={refresco}
            />
          </div>
        </section>
      </div>

      {/* ====================================================== */}
      {/* MODAL CREAR SANCION */}
      {/* ====================================================== */}

      {verSancionar && (
        <ModalCreaSancion
          isOpen={verSancionar}
          onClose={manejaCerradoSancionar}
        >
          <div className="san-v2-modal">
            <div className="san-v2-modal-header">
              <span className="san-v2-modal-eyebrow">
                NUEVA ACTUACIÓN DISCIPLINARIA
              </span>

              <h3>
                Crear sanción
              </h3>

              <p>
                Seleccione el cadete y complete los datos
                correspondientes a la actuación disciplinaria.
              </p>
            </div>

            {!cadeteSeleccionado ? (
              <div className="san-v2-modal-search">
                <div className="san-v2-search-heading">
                  <div className="san-v2-search-icon">
                    🔎
                  </div>

                  <div>
                    <strong>
                      Buscar cadete
                    </strong>

                    <span>
                      Seleccione el cadete sobre el que se
                      registrará la sanción.
                    </span>
                  </div>
                </div>

                <div className="san-v2-search-box">
                  <CadetesBuscador
                    devuelvo={(cadete) =>
                      setCadeteSeleccionado(cadete)
                    }
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="san-v2-selected-person">
                  <div className="san-v2-avatar">
                    {cadeteSeleccionado
                      ?.cadeteApellido
                      ?.charAt(0)
                      ?.toUpperCase() ||
                      cadeteSeleccionado
                        ?.cadeteNombre
                        ?.charAt(0)
                        ?.toUpperCase() ||
                      "C"}
                  </div>

                  <div className="san-v2-selected-info">
                    <span>
                      CADETE SELECCIONADO
                    </span>

                    <strong>
                      {nombreCadete}
                    </strong>

                    <small>
                      DNI{" "}
                      {cadeteSeleccionado?.cadeteDni ||
                        "-"}
                    </small>
                  </div>

                  <button
                    type="button"
                    className="san-v2-change-cadete"
                    onClick={() =>
                      setCadeteSeleccionado(null)
                    }
                  >
                    Cambiar
                  </button>
                </div>

                <div className="san-v2-form-container">
                  <CreaSancion
                    cadete={cadeteSeleccionado}
                    onClose={manejoCierreCreo}
                  />
                </div>
              </>
            )}
          </div>
        </ModalCreaSancion>
      )}
    </div>
  );
};

export default Sancionaa;